import React, { useState, useEffect } from 'react';
import '../styling/forms.css';

const AggressivePatientForm = ({ onSubmit }) => {
  const [form, setForm] = useState({
    incidentDate: new Date().toISOString().split('T')[0],
    incidentTime: '',
    location: '',
    involvedPartyType: 'Patient',
    staffInvolved: '',
    behaviors: [],
    weaponsPresent: 'No',
    injuryOccurred: 'No',
    injuryDetails: '',
    deescalationMethods: [],
    lawEnforcementInvolved: 'No',
    outcome: '',
    followUpNeeded: 'No',
    followUpPlan: ''
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleInArray = (key, value) => {
    setForm((s) => {
      const exists = s[key].includes(value);
      const next = exists ? s[key].filter((v) => v !== value) : [...s[key], value];
      return { ...s, [key]: next };
    });
  };

  const update = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div className="form-wrapper">
      <h1>Aggressive Patient Interaction</h1>
      <form className="card-form" onSubmit={submit}>
        <label>
          Date of Incident
          <input type="date" name="incidentDate" value={form.incidentDate} onChange={update} required />
        </label>
        <label>
          Time of Incident
          <input type="time" name="incidentTime" value={form.incidentTime} onChange={update} />
        </label>
        <label>
          Location/Operatory
          <input name="location" value={form.location} onChange={update} />
        </label>
        <label>
          Involved Party Type
          <select name="involvedPartyType" value={form.involvedPartyType} onChange={update}>
            <option>Patient</option>
            <option>Family/Visitor</option>
            <option>Other</option>
          </select>
        </label>
        <label>
          Staff Involved
          <input name="staffInvolved" value={form.staffInvolved} onChange={update} />
        </label>

        <div>
          <div className="menu-title" style={{textAlign:'left'}}>Observed Behaviors</div>
          <div className="checkbox-group">
            {['Verbal Abuse','Threats','Physical Aggression','Property Damage','Harassment','Refusal to Leave'].map((b) => (
              <label key={b}>
                <input type="checkbox" checked={form.behaviors.includes(b)} onChange={() => toggleInArray('behaviors', b)} /> {b}
              </label>
            ))}
          </div>
        </div>

        <label>
          Weapons Present
          <select name="weaponsPresent" value={form.weaponsPresent} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>

        <label>
          Injury Occurred
          <select name="injuryOccurred" value={form.injuryOccurred} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>

        {form.injuryOccurred === 'Yes' && (
          <label>
            Injury Details
            <textarea name="injuryDetails" rows="4" value={form.injuryDetails} onChange={update} />
          </label>
        )}

        <div>
          <div className="menu-title" style={{textAlign:'left'}}>De-escalation Methods</div>
          <div className="checkbox-group">
            {['Verbal De-escalation','Manager Involved','Security Called','Law Enforcement','Patient Removed','Other'].map((m) => (
              <label key={m}>
                <input type="checkbox" checked={form.deescalationMethods.includes(m)} onChange={() => toggleInArray('deescalationMethods', m)} /> {m}
              </label>
            ))}
          </div>
        </div>

        <label>
          Law Enforcement Involved
          <select name="lawEnforcementInvolved" value={form.lawEnforcementInvolved} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>

        <label>
          Outcome
          <select name="outcome" value={form.outcome} onChange={update}>
            <option value="">Select</option>
            <option>Resolved</option>
            <option>Patient Removed</option>
            <option>Appointment Terminated</option>
            <option>Police Report Filed</option>
            <option>Other</option>
          </select>
        </label>

        <label>
          Follow-up Needed
          <select name="followUpNeeded" value={form.followUpNeeded} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>

        {form.followUpNeeded === 'Yes' && (
          <label>
            Follow-up Plan
            <textarea name="followUpPlan" rows="4" value={form.followUpPlan} onChange={update} />
          </label>
        )}

        <div className="actions">
          <button type="submit" className="primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default AggressivePatientForm;


